<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">생산업체</th>
							<td class="col-1">
								<el-input v-model="menuCpnyCd" />
								<span class="unit input-icon"><i class="icon-sf-search" @click="() => onUserPopup(10)" /></span>
							</td>
							<th class="col-1">납품업체</th>
							<td class="col-1">
								<!-- <el-input v-model="selectedRow.partsName" :onChange="value => onChange({ key: 'partsNo', value })" /> -->
								<el-input v-model="delCpnyCd" />
								<span class="unit input-icon"><i class="icon-sf-search" @click="() => onUserPopup(20)" /></span>
							</td>
							<th class="col-1">OEM업체</th>
							<td class="col-1">
								<!-- <el-input v-model="selectedRow.partsName" :onChange="value => onChange({ key: 'partsNo', value })" /> -->
								<el-input :value="oemCpnyCd" />
								<span class="unit input-icon"><i class="icon-sf-search" @click="() => onUserPopup(30)" /></span>
							</td>
							<th class="col-1">완성차업체</th>
							<td class="col-1">
								<!-- <el-input v-model="selectedRow.partsName" :onChange="value => onChange({ key: 'partsNo', value })" /> -->
								<el-input :value="comCpnyCd" />
								<span class="unit input-icon"><i class="icon-sf-search" @click="() => onUserPopup(40)" /></span>
							</td>
						</tr>
						<tr>
							<th class="col-1">생산업체코드</th>
							<td class="col-1">
								<el-input :value="menuCpnyCd" readOnly />
							</td>
							<th class="col-1">cpnyNm</th>
							<td class="col-1">
								<el-input :value="manuCmpn.cpnyNm" readOnly />
							</td>
							<th class="col-1">partType</th>
							<td class="col-1">
								<el-input :value="manuCmpn.partType" readOnly />
							</td>
							<th class="col-1">crgrNm</th>
							<td class="col-1">
								<el-input :value="manuCmpn.crgrNm" readOnly />
							</td>
							<th class="col-1">crgrTn</th>
							<td class="col-1">
								<el-input :value="manuCmpn.crgrTn" readOnly />
							</td>
							<th class="col-1">eml</th>
							<td class="col-1">
								<el-input :value="manuCmpn.eml" readOnly />
							</td>
							<th class="col-1">regn</th>
							<td class="col-1">
								<el-input :value="manuCmpn.regn" readOnly />
							</td>
						</tr>
						<tr>
							<th class="col-1">delCmpn코드</th>
							<td class="col-1">
								<el-input :value="delCpnyCd" readOnly />
							</td>
							<th class="col-1">cpnyNm</th>
							<td class="col-1">
								<el-input :value="delCmpn.cpnyNm" readOnly />
							</td>
							<th class="col-1">delCmpn.partType</th>
							<td class="col-1">
								<el-input :value="delCmpn.partType" readOnly />
							</td>
							<th class="col-1">oemCpnyCd</th>
							<td class="col-1">
								<el-input :value="oemCpnyCd" readOnly />
							</td>
							<th class="col-1">delCpnyNm</th>
							<td class="col-1">
								<el-input :value="oemCmpn.cpnyNm" readOnly />
							</td>
							<th class="col-1">comCpnyCd</th>
							<td class="col-1">
								<el-input :value="comCpnyCd" readOnly />
							</td>
							<th class="col-1">comCmpn.cpnyNm</th>
							<td class="col-1">
								<el-input :value="comCmpn.cpnyNm" readOnly />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import * as yup from 'yup';
export default {
	data() {
		return {
			//생산업체 검색 저장하는 객체
			didGetParam1: false,
			menuCpnyCd: '',
			manuCmpn: {
				cpnyCd: '',
				cpnyNm: '',
				cmpnScn: '10',
				partType: '',
				crgrNm: '',
				crgrTn: '',
				eml: '',
				regn: ''
			},
			//납품업체 검색 저장하는 객체
			didGetParam2: false,
			delCpnyCd: '',
			delCmpn: {
				cpnyCd: '',
				cpnyNm: '',
				cmpnScn: '20',
				partType: '',
				crgrNm: '',
				crgrTn: '',
				eml: '',
				regn: ''
			},
			//OEM업체 검색 저장하는 객체
			didGetParam3: false,
			oemCpnyCd: '',
			oemCmpn: {
				cpnyCd: '',
				cpnyNm: '',
				cmpnScn: '30',
				partType: '',
				crgrNm: '',
				crgrTn: '',
				eml: '',
				regn: ''
			},
			//완성차업체 검색 저장하는 객체
			didGetParam4: false,
			comCpnyCd: '',
			comCmpn: {
				cpnyCd: '',
				cpnyNm: '',
				cmpnScn: '40',
				partType: '',
				crgrNm: '',
				crgrTn: '',
				eml: '',
				regn: ''
			}
		};
	},
	props: {
		scrId: { type: String, default: '' },
		sendParam: { type: Object }
	},
	created() {},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onUserPopup(param) {
			//this.compPopupParams.cmpnScn = param;
			//console.log('SearchView에서 onUserPopup 실행', param);
			if (param === 10) {
				this.menuCpnyCd = this.manuCmpn.cpnyCd;
				this.$emit('OpenPopup', this.manuCmpn);
			} else if (param === 20) {
				this.delCpnyCd = this.delCmpn.cpnyCd;
				this.$emit('OpenPopup', this.delCmpn);
			} else if (param === 30) {
				this.oemCpnyCd = this.oemCmpn.cpnyCd;
				this.$emit('OpenPopup', this.oemCmpn);
			} else {
				this.comCpnyCd = this.comCmpn.cpnyCd;
				this.$emit('OpenPopup', this.comCmpn);
			}
		}
	},
	watch: {
		sendParam(newValue, oldValue) {
			if (this.sendParam.cmpnScn == '10') {
				this.manuCmpn = this.sendParam;
				this.menuCpnyCd = this.sendParam.cpnyCd;
				this.didGetParam1 = true;
			} else if (this.sendParam.cmpnScn == '20') {
				this.delCmpn = this.sendParam;
				this.delCpnyCd = this.sendParam.cpnyCd;
				this.didGetParam2 = true;
			} else if (this.sendParam.cmpnScn == '30') {
				this.oemCmpn = this.sendParam;
				this.oemCpnyCd = this.sendParam.cpnyCd;
				this.didGetParam3 = true;
			} else if (this.sendParam.cmpnScn == '40') {
				this.comCmpn = this.sendParam;
				this.comCpnyCd = this.sendParam.cpnyCd;
				this.didGetParam4 = true;
			}
		},
		menuCpnyCd(newValue, oldValue) {
			if (!this.didGetParam1) {
				this.manuCmpn = {
					cpnyCd: this.menuCpnyCd,
					cpnyNm: '',
					cmpnScn: '10',
					partType: '',
					crgrNm: '',
					crgrTn: '',
					eml: '',
					regn: ''
				};
				//console.log('this.manuCmpn.cpnyCd :: ', this.manuCmpn);
			} else {
				this.didGetParam1 = false;
			}
		},
		delCpnyCd(newValue, oldValue) {
			if (!this.didGetParam2) {
				this.delCmpn = {
					cpnyCd: this.delCpnyCd,
					cpnyNm: '',
					cmpnScn: '20',
					partType: '',
					crgrNm: '',
					crgrTn: '',
					eml: '',
					regn: ''
				};
			} else {
				this.didGetParam2 = false;
			}
		},
		oemCpnyCd(newValue, oldValue) {
			if (!this.didGetParam3) {
				this.delCmpn = {
					cpnyCd: this.oemCpnyCd,
					cpnyNm: '',
					cmpnScn: '30',
					partType: '',
					crgrNm: '',
					crgrTn: '',
					eml: '',
					regn: ''
				};
			} else {
				this.didGetParam3 = false;
			}
		},
		comCpnyCd(newValue, oldValue) {
			if (!this.didGetParam4) {
				this.delCmpn = {
					cpnyCd: this.comCpnyCd,
					cpnyNm: '',
					cmpnScn: '40',
					partType: '',
					crgrNm: '',
					crgrTn: '',
					eml: '',
					regn: ''
				};
			} else {
				this.didGetParam4 = false;
			}
		}
	}
};
</script>
